import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MovieCard from '@/components/feature/MovieCard';
import SectionHeading from '@/components/feature/SectionHeading';
import { usePageMeta } from '@/hooks/usePageMeta';
import HeroCarousel from './components/HeroCarousel';
import CategoryQuickNav from './components/CategoryQuickNav';
import HomeSidebar from './components/HomeSidebar';
import { getLatestMovies } from '@/utils/movies';

const latestMovies = getLatestMovies(20);

export default function Home() {
  usePageMeta({
    title: '人间中毒在线 - 电影在线观看与剧情介绍',
    description:
      '人间中毒在线为您提供最新电影资源，涵盖剧情介绍和在线观看服务，满足影迷对电影内容的全面需求。',
    keywords: '人间中毒在线,人间中毒,电影在线观看,剧情介绍,影视资源。',
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="pt-16">
        <HeroCarousel />

        <div className="mt-10 md:mt-14">
          <CategoryQuickNav />
        </div>

        <div className="mx-auto mt-10 w-full max-w-[1280px] px-4 md:mt-14 md:px-8">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
            <div className="lg:col-span-8">
              <SectionHeading
                icon="ri-film-line"
                title="最新上映"
                subtitle="精选近期收录的 20 部影片，海报直击，点击查看剧情详情"
                action={
                  <Link
                    to="/category?sort=latest"
                    className="hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-600 transition hover:text-accent-700 sm:flex"
                  >
                    查看更多
                    <i className="ri-arrow-right-s-line"></i>
                  </Link>
                }
              />
              <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 xl:grid-cols-4">
                {latestMovies.map((movie, i) => (
                  <div key={movie.id} className={`anim-fade-up delay-${(i % 5) + 1}`}>
                    <MovieCard movie={movie} />
                  </div>
                ))}
              </div>
            </div>

            <div className="lg:col-span-4">
              <div className="lg:sticky lg:top-24">
                <HomeSidebar />
              </div>
            </div>
          </div>
        </div>

        <section className="mx-auto mt-12 w-full max-w-[1280px] px-4 md:mt-16 md:px-8">
          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <div className="grid grid-cols-1 md:grid-cols-3">
              <div className="border-b border-background-200 p-6 md:border-b-0 md:border-r md:p-8">
                <i className="ri-movie-2-line text-3xl text-accent-500"></i>
                <h3 className="mt-4 text-base font-bold text-foreground-950">关于人间中毒在线</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  我们致力于打造一个干净、好用的电影内容平台，帮助影迷在海量影片中快速找到想看的电影，了解完整剧情，发现更多值得一看的好故事。
                </p>
              </div>
              <div className="border-b border-background-200 p-6 md:border-b-0 md:border-r md:p-8">
                <i className="ri-stack-line text-3xl text-accent-500"></i>
                <h3 className="mt-4 text-base font-bold text-foreground-950">丰富片库与分类</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  涵盖动作、剧情、爱情、科幻、悬疑等多元类型，支持按年代与热度筛选排序，让每一次浏览都更高效。全部影片资料为虚构演示内容。
                </p>
              </div>
              <div className="p-6 md:p-8">
                <i className="ri-heart-3-line text-3xl text-accent-500"></i>
                <h3 className="mt-4 text-base font-bold text-foreground-950">收藏与个性化浏览</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  遇到喜欢的电影可以一键收藏，收藏状态保存在你的本地浏览器中，方便随时回顾。视频播放区为前端演示，敬请期待完整播放功能。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}